import {Signal} from 'typed-signals';

import {RootState, rootState} from '@lib/store/rootState';
import {Action, IStoreProvider, Unsubscribe} from '@lib/store/types';

export const dispatcher = new Signal();

/**
 * reduxでjsの容量大きくならないように超雑に作ったstate管理マン
 * memo化もクソもないしパフォーマンス不安だけどｱｶﾝかったらredux使う
 */
export class StoreProvider implements IStoreProvider {
  static singleton: StoreProvider;

  static create() {
    if (StoreProvider.singleton) {
      return StoreProvider.singleton;
    }
    return (StoreProvider.singleton = new StoreProvider());
  }

  dispatch<A extends Action>(action: ReturnType<A>) {
    return dispatcher.emit(action);
  }

  getState(): RootState {
    return rootState;
  }

  subscribe(listener: () => void): Unsubscribe {
    const ret = dispatcher.connect(listener);
    return ret.enabled ? () => ret.disconnect() : () => {};
  }
}
